var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.serverIsBusy)?_c('div',{staticClass:"project-spinner spinner-holder",class:{'local-spinner':_vm.localSpinner}},[_c('spinner',{attrs:{"animation-duration":1000,"size":100,"color":'#068CFF'}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }